import { createElement } from '../../util/element';

import '@interactjs/auto-start'
import '@interactjs/actions/drag'
import '@interactjs/actions/resize'
import '@interactjs/modifiers'
import '@interactjs/dev-tools'

import interact from '@interactjs/interact'

import { faX } from '@fortawesome/pro-light-svg-icons'
import { icon } from '@fortawesome/fontawesome-svg-core'

import './dialog.css';

const resizableEdges = { top: false, left: true, right: true, bottom: true };

class DialogHeader {
	
	constructor(element) {
		const header = createElement("div", "dialog-header", element);
		this.titleElement = createElement("span", "dialog-header-title", header);
		this.closeElement = createElement("span", "dialog-header-buttons", header);

		this.closeElement.appendChild(icon( faX ).node[0]);
		
		this.element = header;
	}
	
	setTitle(title) {
		this.titleElement.innerText = title;
	}	
}

class Dialog {
	
	constructor(options) {
		const { manager, identifier, title, width, height } = options;
		this.manager = manager;
		this.identifier = identifier;

		const element = createElement("div", "dialog");
		this.header = new DialogHeader(element);
		this.element = element;
		this.content = createElement("div", "dialog-content", element);
								
		this.setTitle(title);
		this.setWidth(width);
		this.setHeight(height);

		if( identifier ) {
			element.setAttribute("data-identifier", identifier);
		}
								
		this.interaction = interact(this.element).draggable({
			listeners: {
      			// call this function on every dragmove event
      			move: dragMoveListener,
      			start: (event) => this.manager.ensureTop(this)    			
  			},
  			allowFrom: this.header.element,
  			modifiers: [
   				interact.modifiers.restrict({
      				//restriction: document.body,
      				//endOnly: false
    			})
  			]
		})
		.resizable({			
			listeners: {
      			// call this function on every dragmove event
      			move: resizeListener
  			},
		});		
		
		const self = this;
		
		function dragMoveListener(event) {
			const target = event.target
			
			// keep the dragged position in the data-x/data-y attributes
			let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
			let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
			
			self.translate(x, y);
			self.storePosition();			  
		}
		
		function resizeListener(event) {
			let { x, y } = event.target.dataset
        	x = (parseFloat(x) || 0) + event.deltaRect.left
        	y = (parseFloat(y) || 0) + event.deltaRect.top

        	Object.assign(event.target.style, {
          		width: `${event.rect.width}px`,
          		height: `${event.rect.height}px`,
        	})

        	Object.assign(event.target.dataset, { x, y })
        	self.storePosition();    	
		};
				
		this.header.closeElement.addEventListener("click", event => {
			this.close();
		})		
	}
	
	bind(options) {
		const { openHandler, closeHandler, container } = options;
		
		if( this.container ) {
			this.content.replaceChildren();
		}
		
		this.openHandler = openHandler;
		this.closeHandler = closeHandler;
		
		this.container = container;			
		this.content.appendChild( this.container );
	}
	
	open(position) {		
		this.openHandler();		
		this.manager.open(this, position);
	}
	
	close() {
		this.manager.close(this);
		this.closeHandler();
	}
	
	storePosition() {
		this.manager.storePosition(this);
	}
	
	translate(x, y) {
		const target = this.element;

		let xPos = x;
		let yPos = y;
		
		const clientWidth = document.documentElement.clientWidth;
		const clientHeight = document.documentElement.clientHeight;
				
		if (x < 0) {
			xPos = 0;
		} else if (x  > clientWidth - target.offsetWidth) {
			xPos = clientWidth - target.offsetWidth;
		}
		
		if (y < 0) {
			yPos = 0;
		} else if (y  > clientHeight - target.offsetHeight) {
			yPos = clientHeight - target.offsetHeight;
		} 

		// translate the element
		target.style.left = `${xPos.toFixed()}px`;
		target.style.top = `${yPos.toFixed()}px`;

	  	// update the position attributes
	  	target.setAttribute('data-x', xPos);
	  	target.setAttribute('data-y', yPos);	
	}
	
	getPosition() {
		const target = this.element;
		const { x, y, width, height } = target.getBoundingClientRect();
				
		return { 
			x: x, 
			y: y, 
			width: width,
			height: height
		};
	}
	
	show() {
		this.element.classList.toggle("dialog-hide", false);
	}
	
	hide() {
		this.element.classList.toggle("dialog-hide", true);
	}
	
	setMinWidth(minWidth) {
		this.element.style.minWidth = `${minWidth}px`;
	}
	
	setMinHeight(minHeight) {
		this.element.style.minHeight = `${minHeight}px`;
	}
	
	setMaxWidth(maxWidth) {
		this.element.style.maxWidth = `${maxWidth}px`;
	}
	
	setMaxHeight(maxHeight) {
		this.element.style.maxHeight = `${maxHeight}px`;
	}
	
	setWidth(width) {
		this.element.style.width = `${width}px`;
	}
	
	setHeight(height) {
		this.element.style.height = `${height}px`;
	}
	
	setResizable(resizable) {	
		let edges = {};
		
		if( resizable ) {
			edges = resizableEdges;
		}
		
		this.interaction.resizable({
			edges: edges
		});
		
	}
	
	setModal(modal) {
		this.modal = modal;
	}
	
	setTitle(title) {
		this.header.setTitle(title);
	}
	
}

export { Dialog }